(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Recently Viewed Products
  const MAX_RECENTLY_VIEWED_PRODUCTS =
    parseInt(document.querySelector('input[name="max_recently_viewd_products"]').value, 10) | 5;

  const productData = JSON.parse(document.getElementById('ProductData').textContent);

  // 最近見た商品をlocalStorageに保存する関数
  function saveRecentlyViewedProduct(product) {
    let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];

    // 同じ商品が既に存在する場合は削除
    recentlyViewed = recentlyViewed.filter((item) => item.id !== product.id);

    // 新しい商品を配列の先頭に追加
    recentlyViewed.unshift({
      id: product.id,
      title: product.title,
      url: window.location.pathname,
      image: product.featured_image,
      price: product.variants[0].price,
      type: product.product_type,
    });

    // 最大5つまでに制限
    recentlyViewed = recentlyViewed.slice(0, MAX_RECENTLY_VIEWED_PRODUCTS);

    // localStorageに保存
    localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewed));
  }

  // ページ読み込み時に実行
  document.addEventListener('DOMContentLoaded', () => {
    saveRecentlyViewedProduct(productData);
  });
  document.addEventListener('DOMContentLoaded', function () {
    const ageOverlay = document.getElementById('age-verify-overlay');
    if (!ageOverlay) return; // alcoholタグなし → 何もしない

    const ageForm = document.getElementById('product-form');
    let ageVerified = false;

    // カートに入れるボタンを押したとき
    ageForm.addEventListener('submit', function (e) {
      if (ageVerified) return; // 確認済みならそのまま送信
      e.preventDefault();     // 未確認ならフォーム送信を止める
      ageOverlay.style.display = 'flex'; // モーダルを表示
    });

    // 「はい（20歳以上）」ボタン
    document.getElementById('age-verify-yes').addEventListener('click', function () {
      ageOverlay.style.display = 'none';
      ageVerified = true;       // 確認済みフラグを立てる
      ageForm.requestSubmit();  // フォームを送信
    });

    // 「いいえ」ボタン
    document.getElementById('age-verify-no').addEventListener('click', function () {
      ageOverlay.style.display = 'none'; // モーダルを閉じるだけ
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-recently-viewed-02"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const recentSection = document.querySelector('.js-section-recent');
    if (!recentSection) return;
    const recentProducts = JSON.parse(localStorage.getItem('recentProducts')) || [];
    // if (recentProducts.length === 0) return;
    if (recentProducts.length === 0) {
      recentSection.style.display = 'none';
    }

    const container = document.querySelector('.js-spSlider__slider');
    if (!container) return;
    const cardTemplate = container.querySelector('.js-template-card');
    if (!cardTemplate) return;
    // .js-spSlider__slider に、 recentProducts の内容を追加する
    recentProducts.forEach(function (product) {
      const card = cardTemplate.cloneNode(true);
      card.classList.remove('js-template-card');
      card.querySelector('.productItem__image img').src = product.image;
      card.querySelector('.productItem__name-01 span').textContent = product.name_kanji;
      card.querySelector('.productItem__name-02 span').textContent = product.name_hiragana;
      card.querySelector('.productItem__name-03 span').textContent = product.name_english;
      card.querySelector('.productItem__price span').textContent = product.price;
      card.querySelector('.productItem').href = product.url;
      container.appendChild(card);
    });
    // Remove the template card
    cardTemplate.remove();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-recently-viewed"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.js-section-recent');
    if (!container) return;
    const is_slider = container.classList.contains('js-common-slider');

    const recentlyViewedList = container.querySelector('.js-section-recent__list');
    const maxProducts = parseInt(container.dataset.maxProducts, 10) || 5; // デフォルトは5商品
    console.log(maxProducts);

    const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];

    // 表示する商品数を制限
    const productsToShow = recentlyViewed.slice(0, maxProducts);

    productsToShow.forEach((product) => {
      const li = document.createElement('li');
      if (is_slider) {
        li.classList.add('swiper-slide');
      }
      li.innerHTML = `
        <div class='card-product-01'>
          <a href='${product.url}' class='card-product-01__inner'>
            <div class='card-product-01__image'>
              <img src='${product.image}' alt='' width='320' height='320'>
            </div>
            <div class='card-product-01__contents'>
              <div class='card-product-01__box'>
                <div class='card-product-01__cat'>
                  <span>${product.type}</span>
                </div>
                <div class='card-product-01__title'>
                  ${product.title}
                </div>
                <div class='card-product-01__price'>
                  <div class='p-price'>${product.price}</div>
                  <div class='p-priceText'>(税込)</div>
                </div>
              </div>
            </div>
          </a>
        </div>
      `;
      recentlyViewedList.appendChild(li);
    });

    // 最近見た商品がない場合、セクションを非表示にする
    if (productsToShow.length === 0) {
      container.style.display = 'none';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
